import { RematchReason } from '@uplift/types';
import { restClient } from '../client';

export type RematchReasonsResponse = {
  rematchReasons: RematchReason[];
};

export const getRematchReasons = () => {
  return restClient.request<RematchReasonsResponse>('/api/v1/matching/rematch_reasons');
};
